/**
 * Product delivery estimate: countdown to daily cutoff + estimated delivery range.
 * One init per page; safe if script tag appears more than once.
 */
(function () {
  function ordinalEn(n) {
    const s = ['th', 'st', 'nd', 'rd'];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  }

  function formatDeliveryDate(date, locale) {
    const weekday = date.toLocaleDateString(locale, { weekday: 'long' });
    const month = date.toLocaleDateString(locale, { month: 'long' });
    const day = date.getDate();
    const lang = (locale || 'en').toLowerCase();
    const dayPart = lang.startsWith('en') ? ordinalEn(day) : String(day);
    return weekday + ', ' + dayPart + ' ' + month;
  }

  function atNoon(y, m, d) {
    return new Date(y, m, d, 12, 0, 0);
  }

  function addCalendarDays(date, n) {
    const x = new Date(date.getFullYear(), date.getMonth(), date.getDate() + n, 12, 0, 0);
    return x;
  }

  function addBusinessDaysFrom(date, n) {
    const base = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0);
    if (n <= 0) return base;
    let d = new Date(base);
    let left = n;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      const wd = d.getDay();
      if (wd !== 0 && wd !== 6) left -= 1;
    }
    return d;
  }

  function getTodayCutoff(ch, cm) {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate(), ch, cm, 0, 0);
  }

  function getNextDeadline(ch, cm) {
    const now = new Date();
    const t = getTodayCutoff(ch, cm);
    if (now.getTime() <= t.getTime()) return t;
    return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, ch, cm, 0, 0);
  }

  function getShipDateStart(ch, cm) {
    const now = new Date();
    const t = getTodayCutoff(ch, cm);
    if (now.getTime() < t.getTime()) {
      return atNoon(now.getFullYear(), now.getMonth(), now.getDate());
    }
    return atNoon(now.getFullYear(), now.getMonth(), now.getDate() + 1);
  }

  function formatCountdown(ms, labels) {
    var secLabel = labels.seconds || 'seconds';
    var secOne = labels.second || 'second';
    if (ms <= 0) return '0 ' + secLabel;
    var totalSec = Math.floor(ms / 1000);
    var h = Math.floor(totalSec / 3600);
    var m = Math.floor((totalSec % 3600) / 60);
    var s = totalSec % 60;
    var parts = [];
    if (h > 0) {
      parts.push(h + ' ' + (h === 1 ? labels.hour : labels.hours));
      parts.push(m + ' ' + (m === 1 ? labels.minute : labels.minutes));
    } else if (m > 0) {
      parts.push(m + ' ' + (m === 1 ? labels.minute : labels.minutes));
    }
    parts.push(s + ' ' + (s === 1 ? secOne : secLabel));
    return parts.join(' ');
  }

  function tick(root) {
    const ch = parseInt(root.getAttribute('data-cutoff-hour'), 10) || 14;
    const cm = parseInt(root.getAttribute('data-cutoff-minute'), 10) || 0;
    let minT = parseInt(root.getAttribute('data-transit-min'), 10);
    let maxT = parseInt(root.getAttribute('data-transit-max'), 10);
    if (!Number.isFinite(minT)) minT = 3;
    if (!Number.isFinite(maxT)) maxT = 8;
    if (maxT < minT) maxT = minT;
    const business = root.getAttribute('data-business-days') === 'true';
    const locale = root.getAttribute('data-locale') || 'en';

    const labels = {
      hours: root.getAttribute('data-label-hours') || 'hours',
      hour: root.getAttribute('data-label-hour') || 'hour',
      minutes: root.getAttribute('data-label-minutes') || 'minutes',
      minute: root.getAttribute('data-label-minute') || 'minute',
      seconds: root.getAttribute('data-label-seconds') || 'seconds',
      second: root.getAttribute('data-label-second') || 'second',
    };

    const deadline = getNextDeadline(ch, cm);
    const now = new Date();
    const left = deadline.getTime() - now.getTime();

    const ship = getShipDateStart(ch, cm);
    let d1;
    let d2;
    if (business) {
      d1 = addBusinessDaysFrom(ship, minT);
      d2 = addBusinessDaysFrom(ship, maxT);
    } else {
      d1 = addCalendarDays(ship, minT);
      d2 = addCalendarDays(ship, maxT);
    }

    const elCount = root.querySelector('[data-de-countdown]');
    const elStart = root.querySelector('[data-de-date-start]');
    const elEnd = root.querySelector('[data-de-date-end]');

    if (elCount) {
      elCount.textContent = formatCountdown(left, labels);
    }
    if (elStart) {
      elStart.textContent = formatDeliveryDate(d1, locale);
    }
    if (elEnd) {
      elEnd.textContent = formatDeliveryDate(d2, locale);
    }
  }

  function initRoot(root) {
    if (root.getAttribute('data-de-ready')) return;
    root.setAttribute('data-de-ready', '1');
    tick(root);
    window.setInterval(function () {
      tick(root);
    }, 1000);
  }

  function boot() {
    document.querySelectorAll('[data-delivery-estimate]').forEach(initRoot);
  }

  if (!window.__productDeliveryEstimateSetup) {
    window.__productDeliveryEstimateSetup = true;
    document.addEventListener('DOMContentLoaded', boot);
  }
  if (document.readyState !== 'loading') {
    boot();
  }
})();
